import { Document, Page, StyleSheet, Font, Text, Image, View } from "@react-pdf/renderer";
import React from "react";
import dayjs from "dayjs";
import font from "../assets/fonts/Inter.ttf";
import firma from "../assets/img/firma.png";
import getAge from "../utils/getAge";

const PDFGen = ({ patientInfo, hasCovid, orderDetails, symptomsList }) => {
  const getSymptoms = (symptoms) => {
    // Only care about positions 0 = Fiebre, 1 = tos, 6 = olfato/gusto, 8 = diarrea
    let list = [];
    if (symptoms[0] === true) list.push("R50.9");
    if (symptoms[1] === true) list.push("R05.9");
    if (symptoms[6]) {
      list.push("R43.0");
      list.push("R43.0");
    }
    if (symptoms[8]) list.push("R19.7");
    return list;
  };

  /**
   * Returns the order strings to be place on the PDF
   * @param {string} type
   * @param {string} testType
   * @returns {{label, dx}}
   */
  const orderObj = (type, testType) => {
    let typeString = type + (type === "COVID" ? testType : "");
    let covidDx = hasCovid ? "U07.1" : "Dx. Z20.822";

    switch (typeString) {
      case "COVIDPCR":
        return { label: "Covid-19 PCR test", dx: covidDx };
      case "COVIDAntígeno":
        return { label: "Covid-19 antigen test", dx: covidDx };
      case "COVIDID-NOW":
        return { label: "Covid-19 ID-NOW RNA", dx: covidDx };
      case "COVIDIgG Spike Protein":
        return { label: "Covid-19 IgM/ IGg Ab", dx: covidDx }; // ?
      case "COVIDSerológica":
        return { label: "Covid-19 spike Ab", dx: "Dx. Z23" }; // ?
      case "INFLUENZA":
        return { label: "Influenza A/B", dx: "Dx. R50.9 , R05.9 , J11.1" };
      case "MYCOPLASMA":
        return { label: "Mycoplasma Pneumoniae IgM", dx: "Dx. A49.9 , R50.9" };
      case "PREGNANCY":
        return { label: "βHCG", dx: "Dx. N91.2" };
      case "VDRL":
        return { label: "VDRL", dx: "Dx. Z02.79 , Z11.3" };
      case "PPD":
        return { label: "PPD test", dx: "Dx. Z02.79" };
      case "CXR":
        return { label: "CXR AP", dx: "Dx. Z02.79" };
      default:
        return null;
    }
  };

  const today = dayjs().format("MM/DD/YYYY");
  const age = getAge(patientInfo.dob);
  const name = `${patientInfo.pfname} ${patientInfo.pfname2} ${patientInfo.plname}  ${patientInfo.plname2}`;
  const symptomsArray = getSymptoms(symptomsList);
  const order = orderObj(orderDetails.type, orderDetails.testType);
  return (
    <Document>
      <Page size="A4" style={styles.page}>
        {/* HEADER */}
        <View style={styles.section}>
          <Text style={styles.header}>Rhina M. Calderón Vargas MD</Text>
          <View style={{ flexDirection: "row", justifyContent: "space-between" }}>
            <Text>Licencia #21416</Text>
            <Text>DEA: FC8498001</Text>
          </View>
          <Text>NPI: 1659839017</Text>
          <View style={styles.separator} />
        </View>

        {/* BODY */}
        <View style={styles.body}>
          <View style={styles.section}>
            <Text>
              Nombre: <Underline text={name} />
            </Text>
            <Text>
              Dirección: <Underline text={patientInfo.paddress} />
            </Text>
            <View style={{ flexDirection: "row", justifyContent: "space-between" }}>
              <Text>
                Edad: <Underline text={age} />
              </Text>
              <Text style={{ marginRight: 10 }}>
                Fecha: <Underline text={today} />
              </Text>
            </View>
          </View>

          {/* CONTENT */}
          <View style={styles.section}>
            <View
              style={{
                flexDirection: "column",
                flexWrap: "wrap",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Text style={{ fontSize: 18 }}>{order?.label}</Text>
            </View>
          </View>
          <View
            style={{
              flexDirection: "column",
              flexWrap: "wrap",
              justifyContent: "flex-end",
              alignItems: "center",
            }}
          >
            <Text style={{ fontSize: 18 }}>{order?.dx}</Text>
            {symptomsArray.map((symptom) => (
              <Text key={symptom.toLowerCase()} style={{ fontSize: 18 }}>
                {symptom}
              </Text>
            ))}
          </View>

          {/* SIGNATURE */}
          <View style={styles.section}>
            {/* <Text>Firma</Text> */}
            <Image style={styles.image} src={firma} cache />
          </View>
        </View>
      </Page>
    </Document>
  );
};

const Underline = ({ text }) => {
  return <Text style={{ textDecoration: "underline" }}>{text}</Text>;
};
Font.register({
  // family: "Roboto",
  family: "Inter",
  src: font,
  // src: "https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-light-webfont.ttf",
});

const styles = StyleSheet.create({
  page: {
    flexDirection: "column",
    backgroundColor: "#fff",
    fontFamily: "Inter",
  },
  image: {
    width: 200,
    height: 200,
  },
  header: {
    fontSize: 30,
    textAlign: "center",
  },
  separator: {
    borderBottomColor: "black",
    borderBottomWidth: 3,
    marginTop: 5,
  },
  section: {
    margin: 10,
    padding: 5,
  },
  body: {
    flexGrow: 1,
    flexDirection: "column",
    justifyContent: "space-between",
    lineHeight: 2,
  },
});

export default PDFGen;
